import { render, staticRenderFns } from "./timeProduct.vue?vue&type=template&id=0b96dfb6&scoped=true&"
import script from "./timeProduct.vue?vue&type=script&lang=js&"
export * from "./timeProduct.vue?vue&type=script&lang=js&"
import style0 from "./timeProduct.vue?vue&type=style&index=0&id=0b96dfb6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b96dfb6",
  null
  
)

export default component.exports